import { siteConfig } from './site'

const EMAILS = {
  MAIN: 'hello@backlinkgpt.com',
  SUPPORT: 'support@backlinkgpt.com',
  TRANSACTIONAL: 'noreply@mail.backlinkgpt.com',
}

const getMailtoLink = (email: string) => `mailto:${email}`
const getMailFrom = (email: string, name = siteConfig.name) => `${name} <${email}>`

export const emailsConfig = {
  main: EMAILS.MAIN,
  mainLink: getMailtoLink(EMAILS.MAIN),
  mainFrom: getMailFrom(EMAILS.MAIN),

  support: EMAILS.SUPPORT,
  supportLink: getMailtoLink(EMAILS.SUPPORT),
  supportFrom: getMailFrom(EMAILS.SUPPORT),

  transactional: EMAILS.TRANSACTIONAL,
  transactionalLink: getMailtoLink(EMAILS.TRANSACTIONAL),
  transactionalFrom: getMailFrom(EMAILS.TRANSACTIONAL),
} as const

export type TEmailsConfig = typeof emailsConfig
